export default __webpack_public_path__ + "static/media/737.01686b75.gif";